// src/components/PageFlash/PageFlash.js
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./PageFlash.css";

export default function PageFlash({ duration = 900 }) {
  const { pathname, key } = useLocation();
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // retrigger animation
    setActive(false);
    const el = ref.current;
    if (el) {
      // force reflow so the class re-applies
      // eslint-disable-next-line no-unused-expressions
      el.offsetHeight;
    }
    setActive(true);

    const end = () => setActive(false);
    el?.addEventListener("animationend", end, { once: true });

    const t = setTimeout(end, duration + 80); // safety
    return () => {
      el?.removeEventListener("animationend", end);
      clearTimeout(t);
    };
  }, [pathname, key, duration]);

  return (
    <div
      ref={ref}
      className={`PageFlashOverlay ${active ? "is-active" : ""}`}
      style={{ "--flash-duration": `${duration}ms` }}
      aria-hidden="true"
    />
  );
}
